export default __webpack_public_path__ + "static/fcc-vertical-300x600-068031fea2188027da26e1f9a9402ae3.png";